import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [

    {
        path: '/proIndex',
        name: 'proIndex',
        meta: {
            title: '首页',
            keepAlive: true,
            requireAuth: true,
            metatitle:
                '感算商城_一站式传感器产品交易平台_现货传感器元器件采购_提供专业技术服务',
        },
        component: () => import('/src/view/Layout/ProIndex.vue'),
        redirect: (to) => ({ name: 'mineMessage' }),
        children: [
            {
                path: '/details/:id',
                name: 'details',
                meta: {
                    title: '商品详情',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Goods/Goods.vue'),
            },
            {
                path: '/contrast',
                name: 'contrast',
                meta: {
                    title: '对比',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Goods/Contrast.vue'),
            },
            {
                path: '/cms/:id',
                name: 'content',
                meta: {
                    title: '文章',
                    keepAlive: false,
                    requireAuth: true,
                    metatitle: '-感算商城',
                },
                component: () => import('/src/view/ProHome/Content.vue'),
            },
            {
                path: '/settled',
                name: 'settled',
                meta: {
                    title: '供应商合作',
                    keepAlive: false,
                    requireAuth: true,
                    metatitle: '供应商合作-感算商城',
                },
                component: () => import('/src/view/ProHome/Settled.vue'),
            },
            {
                path: '/technology',
                name: 'technology',
                meta: {
                    title: '技术服务',
                    keepAlive: false,
                    requireAuth: true,
                    metatitle: '技术服务-感算商城',
                },
                component: () => import('/src/view/ProHome/Technology.vue'),
            },
            {
                path: '/technicalservice',
                name: 'technicalservice',
                meta: {
                    title: '技术服务',
                    keepAlive: false,
                    requireAuth: true,
                    metatitle: '方案定制-感算商城',
                },
                component: () => import('/src/view/ProHome/Service.vue'),
            },
            {
                path: '/module',
                name: 'module',
                meta: {
                    title: '定制服务',
                    keepAlive: false,
                    requireAuth: true,
                    metatitle: '定制服务-感算商城',
                },
                component: () =>
                    import('/src/view/ProHome/CustomizedService.vue'),
            },
            {
                path: '/murataIndex',
                name: 'murataIndex',
                meta: {
                    title: '村田专区',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Murata/Index.vue'),
            },
            {
                path: '/modelMurata',
                name: 'modelMurata',
                meta: {
                    title: '村田专区',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Murata/ModellistMurata.vue'),
            },
            {
                path: '/goodsMurata',
                name: 'goodsMurata',
                meta: {
                    title: '村田热销模块',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Murata/GoodslistMurata.vue'),
            },
            {
                path: '/cart_index',
                name: 'shop',
                meta: {
                    title: '购物车',
                    metatitle: '购物车-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Shop/Shop.vue'),
            },
            {
                path: '/canSampleApply',
                name: 'canSampleApply',
                meta: {
                    title: '样品清单',
                    keepAlive: false,
                    requireAuth: true,
                    metatitle: '样品清单-感算商城',
                },
                component: () =>
                    import('/src/view/CanSampleApply/CanSampleApply.vue'),
            },
            {
                path: '/order',
                name: 'order',
                meta: {
                    title: '订单结算',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Order/spotOrderSumbit/Order.vue'),
            },
            {
                path: '/futuresOrder',
                name: 'futuresOrder',
                meta: {
                    title: '期货订单结算',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Order/futuresOrderSumbit/index.vue'),
            },
            {
                path: '/canSampleApplyOrder',
                name: 'canSampleApplyOrder',
                meta: {
                    title: '样品申请',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () =>
                    import('/src/view/CanSampleApply/CanSampleApplyOrder.vue'),
            },
            {
                path: '/canSampleCheckstand',
                name: 'canSampleCheckstand',
                meta: {
                    title: '样品申请提交反馈',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () =>
                    import('/src/view/CanSampleApply/CanSampleCheckstand.vue'),
            },
            {
                path: '/checkstand',
                name: 'checkstand',
                meta: {
                    title: '结算',
                    keepAlive: true,
                    requireAuth: true,
                },
                component: () => import('/src/view/Order/pay/Checkstand.vue'),
            },
            {
                path: '/payResult',
                name: 'payResult',
                meta: {
                    title: '支付反馈',
                    keepAlive: true,
                    requireAuth: true,
                },
                component: () => import('/src/view/Order/pay/PayResult.vue'),
            },
            {
                path: '/nocheckstand',
                name: 'nocheckstand',
                meta: {
                    title: '结算',
                    keepAlive: true,
                    requireAuth: true,
                },
                component: () => import('/src/view/Order/ApplySuccess.vue'),
            },
            {
                path: '/orderDetails',
                name: 'orderDetails',
                meta: {
                    title: '订单详情',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Order/orderDetail/OrderDetails.vue'),
            },
            {
                path: '/splitOrderDetail',
                name: 'splitOrderDetail',
                meta: {
                    title: '订单拆分详情',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Order/orderDetail/SplitOrderDetail.vue'),
            },
            {
                path: '/sampleDetails',
                name: 'sampleDetails',
                meta: {
                    title: '订单详情',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () =>
                    import('/src/view/CanSampleApply/sampleDetails.vue'),
            },
            {
                path: '/q',
                name: 'q',
                meta: {
                    title: '有奖反馈',
                    keepAlive: false,
                    requireAuth: true,
                    metatitle: '有奖反馈-感算商城',
                },
                component: () => import('/src/view/ProHome/Complaints.vue'),
            },
            {
                path: '/applysuccess',
                name: 'applysuccess',
                meta: {
                    title: '提交成功',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/ProHome/ApplySuccess.vue'),
            },
            {
                path: '/activitySample/:activitySn',
                name: 'activitySample',
                meta: {
                    title: '样品活动',
                    keepAlive: false,
                    requireAuth: false,
                    metatitle: '样品活动-感算商城',
                },
                component: () => import('/src/view/Activity/sample.vue'),
            },
            {
                path: '/findMaterials',
                name: 'findMaterials',
                meta: {
                    title: '全球免费找料订货活动',
                    keepAlive: false,
                    requireAuth: false,
                    metatitle: '全球免费找料订货活动-感算商城',
                },
                component: () => import('/src/view/Activity/findMaterials.vue'),
            },
            {
                path: '/carnival',
                name: 'carnival',
                meta: {
                    title: '压力传感器嘉年华',
                    keepAlive: false,
                    requireAuth: false,
                    metatitle: '压力传感器嘉年华-感算商城',
                },
                component: () => import('/src/view/Activity/carnival.vue'),
            },
            {
                path: '/activityStandard/10005.html',
                name: 'activityStandard_10005',
                meta: {
                    title: '直流无刷优选方案',
                    keepAlive: false,
                    requireAuth: false,
                    metatitle: '直流无刷优选方案-感算商城',
                },
                component: () => import('/src/view/Activity/activityStandard_10005.vue'),
            },
            {
                path: '/activitySample/10006.html',
                name: 'activitySample_10006',
                meta: {
                    title: '0元传感器申请',
                    keepAlive: false,
                    requireAuth: false,
                    metatitle: '0元传感器申请-感算商城',
                },
                component: () => import('/src/view/Activity/activitySample_10006.vue'),
            },
            {
                path: '/customizationDetail/:id',
                name: 'customizationDetail',
                meta: {
                    title: '传感器定制',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () =>
                    import('/src/view/ProHome/customizationDetail.vue'),
            },
            {
                path: '/404',
                name: 'NotFound',
                component: () => import('/src/view/ProHome/404.vue'),
                meta: {
                    title: '404 页面-感算商城',
                    metatitle: '404 页面-感算商城',
                },
            },
            // 当什么都没有匹配到的时候，重定向页面到 404 页面
            { path: '/:catchAll(.*)', redirect: '/404', name: 'notMatch' },
        ],
    },
    {
        path: '/loginlayout',
        name: 'loginlayout',
        meta: {
            title: '登录',
            metatitle: '登入中心-感算商城',
            keepAlive: false,
            requireAuth: true,
        },
        component: () => import('/src/view/Login/Index.vue'),
        redirect: (to) => ({ name: 'login' }),
        children: [
            {
                path: '/login',
                name: 'login',
                meta: {
                    title: '登录',
                    metatitle: '登入中心-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Login/Login.vue'),
            },
            {
                path: '/forget',
                name: 'forget',
                meta: {
                    title: '忘记密码',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Login/Forget.vue'),
            }
        ],
    },
    {
        path: '/center',
        name: 'mine',
        meta: {
            title: '个人信息',
            keepAlive: true,
            requireAuth: true,
        },
        component: () => import('/src/view/Layout/Mine.vue'),
        children: [
            {
                path: '/mineMessage',
                name: 'mineMessage',
                meta: {
                    title: '系统消息',
                    metatitle: '我的消息-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineMessage.vue'),
            },
            {
                path: '/mineCoupon',
                name: 'mineCoupon',
                meta: {
                    title: '我的优惠券',
                    metatitle: '我的优惠券-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineCoupon.vue'),
            },
            {
                path: '/mineInformation',
                name: 'mineInformation',
                meta: {
                    title: '我的信息',
                    metatitle: '个人资料-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () =>
                    import('/src/view/Mine/MineIneInformation.vue'),
            },
            {
                path: '/mineOrder',
                name: 'mineOrder',
                meta: {
                    title: '我的订单',
                    metatitle: '交易订单-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineOrder.vue'),
            },
            {
                path: '/mineAddress',
                name: 'mineAddress',
                meta: {
                    title: '我的地址',
                    metatitle: '收货地址-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineAddress.vue'),
            },
            {
                path: '/mineCanSampleApply',
                name: 'mineCanSampleApply',
                meta: {
                    title: '样品订单',
                    metatitle: '样品订单-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () =>
                    import('/src/view/Mine/MineCanSampleApply.vue'),
            },
            {
                path: '/mineCollection',
                name: 'mineCollection',
                meta: {
                    title: '我的收藏',
                    metatitle: '我的收藏-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineCollection.vue'),
            },
            {
                path: '/mineInvoice',
                name: 'mineInvoice',
                meta: {
                    title: '我的发票',
                    metatitle: '我的发票-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineInvoice.vue'),
            },
            {
                path: '/mineInvoiceTitle',
                name: 'mineInvoiceTitle',
                meta: {
                    title: '发票抬头',
                    metatitle: '发票抬头-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineInvoiceTitle.vue'),
            },
            {
                path: '/mineFootprint',
                name: 'mineFootprint',
                meta: {
                    title: '我的足迹',
                    metatitle: '我的足迹-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineFootprint.vue'),
            },
            {
                path: '/mineComplaints',
                name: 'mineComplaints',
                meta: {
                    title: '我的投诉',
                    metatitle: '投诉管理-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineComplaints.vue'),
            },
            {
                path: '/mineConsult',
                name: 'mineConsult',
                meta: {
                    title: '询价&交期',
                    metatitle: '询价&交期-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineConsult.vue'),
            },
            {
                path: '/mineTechnology',
                name: 'mineTechnology',
                meta: {
                    title: '技术服务',
                    metatitle: '技术服务-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineTechnology.vue'),
            },
            {
                path: '/mineCustomization',
                name: 'mineCustomization',
                meta: {
                    title: '传感器定制',
                    metatitle: '传感器定制-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineCustomization.vue'),
            },
            {
                path: '/bill',
                name: 'bill',
                meta: {
                    title: '查看发票',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/Bill.vue'),
            },
            {
                path: '/mineForm',
                name: 'mineForm',
                meta: {
                    title: '定制服务',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineForm.vue'),
            },
            {
                path: '/mineSettlement',
                name: 'mineSettlement',
                meta: {
                    title: '供应商合作',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/mineSettlement.vue'),
            },
            {
                path: '/mineMessageBook',
                name: 'mineMessageBook',
                meta: {
                    title: '短信订阅',
                    metatitle: '短信订阅-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/mineMessageBook.vue'),
            },
            {
                path: '/mineSampleActivity',
                name: 'mineSampleActivity',
                meta: {
                    title: '样品活动',
                    metatitle: '样品活动-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineSampleActivity.vue'),
            },
            {
                path: '/mineCanSampleApplyList',
                name: 'mineCanSampleApplyList',
                meta: {
                    title: '样品申请-列表',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineCanSampleApplyList.vue'),
            },
            {
                path: '/mineOrderGoods',
                name: 'mineOrderGoods',
                meta: {
                    title: '订货服务',
                    metatitle: '订货服务-感算商城',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Mine/MineOrderGoods.vue'),
            },
        ],
    },
    {
        path: '/service',
        name: 'service',
        meta: {
            title: '我的订单',
            keepAlive: true,
            requireAuth: true,
        },
        component: () => import('/src/view/Layout/Service.vue'),
        children: [
            {
                path: '/complaints',
                name: 'complaints',
                meta: {
                    title: '投诉',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () => import('/src/view/Service/Complaints.vue'),
            },
            {
                path: '/complaintsDetails',
                name: 'complaintsDetails',
                meta: {
                    title: '投诉原因',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () =>
                    import('/src/view/Service/ComplaintsDetails.vue'),
            },
            {
                path: '/afterSalesDetails',
                name: 'afterSalesDetails',
                meta: {
                    title: '申请退款',
                    keepAlive: false,
                    requireAuth: true,
                },
                component: () =>
                    import('/src/view/Service/AfterSalesDetails/index.vue'),
                beforeEnter(to, from, next) {
                    const store = useUserStore();
                    if ((store.userInfo as any).id) {
                        next();
                    } else {
                        next('login');
                    }
                },
            },
        ],
    },
    {
        path: '/customer',
        name: 'customer',
        meta: {
            title: '客服',
            metatitle: '在线客服-感算商城',
            keepAlive: false,
            requireAuth: true,
        },
        component: () => import('@/components/ProShop/Customer/Customer.vue'),
    },
    {
        path: '/gs/crm/api/wxLogin',
        name: 'wxLogin',
        meta: {
            title: '微信跳转页',
            keepAlive: false,
            requireAuth: true,
        },
        component: () => import('/src/view/Login/WX.vue'),
    },
    {
        path: '/qwClientDetail',
        name: 'qwClientDetail',
        meta: {
            title: '客户信息',
            metatitle: '客户信息-感算商城',
            keepAlive: false,
            requireAuth: true,
        },
        component: () => import('@/view/QwClient/QwClientDetail.vue'),
    },
    {
        path: '/mineLogout',
        name: 'mineLogout',
        meta: {
            title: '账号注销',
            metatitle: '账号注销-感算商城',
            keepAlive: false,
            requireAuth: true,
        },
        component: () => import('/src/view/Mine/MineLogout.vue'),
    },
    {
        path: '/mineLogoutSuc',
        name: 'mineLogoutSuc',
        meta: {
            title: '账号注销',
            metatitle: '账号注销-感算商城',
            keepAlive: false,
            requireAuth: true,
        },
        component: () => import('/src/view/Mine/MineLogoutSuc.vue'),
    },
    {
        path: '/mineAudit',
        name: 'mineAudit',
        meta: {
            title: '企业认证',
            metatitle: '企业认证-感算商城',
            keepAlive: false,
            requireAuth: true,
        },
        component: () => import('/src/view/Mine/MineAudit.vue'),
    },
    {
        path: '/form',
        name: 'form',
        meta: {
            keepAlive: true,
            requireAuth: true,
        },
        component: () => import('/src/view/Layout/Form.vue'),
        children: [
            {
                path: '/consult',
                name: 'consult',
                meta: {
                    title: '询价',
                    keepAlive: false,
                    requireAuth: true,
                    metatitle: '询价-感算商城',
                },
                component: () => import('/src/view/ProHome/Consult.vue'),
            },
        ],
    }
];

const router = createRouter({
    history: createWebHistory('/mall'),
    routes: routes,
});
import { useUserStore } from '@/store/User';
// 每次页面跳转回到顶部
router.afterEach((to, from) => {
    if (localStorage.getItem('user')) {
        const store = useUserStore();
        let { userInfo } = JSON.parse(localStorage.getItem('user'));
        if (userInfo) {
            store.userInfo = userInfo;
        }
    }
    window.scrollTo(0, 0);
});
// 不需要判断是不是登陆的页面
const noLoginArr = [
    'proHome',
    'NotFound',
    'sitemap',
    'login',
    'register',
    'forget',
    'wxLogin',
    'settled',
    'customer',
    'technicalservice',
    'consult',
    'Modellist',
    'customization',
    'modelIndex',
    'module',
    'technology',
    "activitySample",
    "customizationDetail",
    "findMaterials",
    "carnival",
    "activityStandard_10005",
    "activitySample_10006",
    "qwClientDetail",
    "mineLogout",
    "mineLogoutSuc"
];
// const noLoginArr = ['NotFound', 'sitemap', 'proHome', 'login', 'register', 'forget', 'allCategories', 'content', 'volume', 'modelIndex', 'Information', 'Goodslist', 'Modellist', 'NewGoods', 'ServicePage', 'murataIndex', 'modelMurata', 'goodsMurata', 'wxLogin', 'customization', 'customizationDetail', 'searchContent', 'brandIndex']
// 判断是否是登陆状态

/*
 * to 要跳转到哪里
 * from 从哪里跳转来
 * next 是一个方法，可以传入下一个跳转路由的路径，如果不传参数，代表直接跳转到to这个路由
 */
router.beforeEach((to, from, next) => {
    if (Object.keys(to.meta).length > 0 && to.matched.length > 0) {
        let this_meta = to.matched[to.matched.length - 1].meta;
        if (this_meta.metatitle) document.title = this_meta.metatitle;
        if (this_meta.keywords) {
            var metaDescription = document.querySelector(
                'meta[name="keywords"]',
            );
            metaDescription.setAttribute('content', this_meta.keywords);
        }
        if (this_meta.description) {
            var metaDescription = document.querySelector(
                'meta[name="description"]',
            );
            metaDescription.setAttribute('content', this_meta.description);
        }
        var headHTML = document.getElementsByTagName('head')[0].innerHTML;
        headHTML +=
            '<link data-n-head="ssr" rel="canonical" href="' +
            window.location.href +
            '">';
        document.getElementsByTagName('head')[0].innerHTML = headHTML;
    }
    // 进行判断，如果to路径没有匹配到现有的任何一个路由
    // 作用：当to的路由为空时不跳转，同时当from的路由也为空时，则跳转到首页
    let fullPathQuery = JSON.parse(JSON.stringify(to.query));
    let fullParamsPathQuery = JSON.parse(JSON.stringify(to.params));
    let fullPath = {
        name: to.name,
        query: fullPathQuery,
        params: fullParamsPathQuery,
    };
    const store = useUserStore();
    let user = JSON.parse(localStorage.getItem('user')) || {}
    let userInfo = {}
    userInfo = user.userInfo || {}
    if (to.name !== 'login' && localStorage.getItem('reloadNow') !== '1') {
        // if (localStorage.getItem('user')) {
        store.lastPath = fullPath;
        // }
    }
    console.log(userInfo, 'userInfo')
    if (noLoginArr.indexOf(to.name) == -1 && userInfo.id === undefined) {
        next({
            name: 'login',
            query: {
                callback: encodeURI(location.href)
            }
        });
    } else {
        next();
    }
});

// 路由报错
router.onError((error) => {
    if (error.message.includes('Failed to fetch dynamically imported module')) {
        window.location.reload();
    }
});
export default router;
